/**
 * @author       matt@zumper.com (Matthieu Devlin)
 * @copyright    Copyright (c) 2024, Zumper
 * @description  Finds and returns match corresponding to the matching route path
 */

import type { Location } from 'history'

import type { match } from 'react-router-dom'
import { matchRoutes } from './matchRoutes'
import type { Branch, ZumperRoute } from './types'

export const getMatchForPath = <
  Params extends { [K in keyof Params]?: string | undefined } = {},
>(
  routes: ZumperRoute<Params>[],
  location: Location<unknown>,
  routePath: string
): match<Params> | undefined => {
  const branch: Branch<Params> = []
  matchRoutes(routes, location, { branch })
  return branch.find((leaf) => leaf.match.path === routePath)?.match
}
